import React from 'react';

const Solutions = () => {
  return (
    <section className="solutions-split">
      <div className="solutions-split-card">
        <div className="solutions-split-left">
          <h2 className="solutions-split-title solutions-split-title-xl">
            IT Asset Disposition Solutions That Work
          </h2>
          <p className="solutions-split-desc">
            With certified facilities and secure processes across North America, we handle IT asset disposition at any scale — turning retired equipment into recovered value while ensuring complete data security and environmental compliance.
          </p>
          <ul className="solutions-split-bullets solutions-split-bullets-icons">
            <li><span className="solutions-badge" aria-hidden>▣</span>Our team brings 100+ years of combined experience in IT asset management, addressing the unique challenges your technology lifecycle faces.</li>
            <li><span className="solutions-badge" aria-hidden>▣</span>Our certified facilities ensure NIST 800-88 compliant data destruction and R2/e-Stewards environmental standards.</li>
            <li><span className="solutions-badge" aria-hidden>▣</span>Our systems were developed for enterprise environments—tracking, evaluating, and optimizing your IT assets based on real-world recovery potential.</li>
          </ul>
        </div>
        <div className="solutions-split-media">
          <img
            src="/service.jpg"
            alt="Secure data destruction and asset recovery"
            className="solutions-split-media-inner"
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
      </div>
    </section>
  );
};

export default Solutions;
